exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-date-table td.today span,\n.el-select-dropdown__item.selected,\n.el-date-table td.available:hover {\n  color: #0095f1;\n}\n.el-date-table td.start-date span,\n.el-date-table td.end-date span {\n  background-color: #0095f1;\n}\n", ""]);

// exports
